var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "feedback-detail-modal",
      attrs: {
        title: _vm.title,
        width: 1000,
        footer: null,
        destroyOnClose: "",
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("TableList", {
        staticStyle: { width: "100%", "margin-top": "5px" },
        attrs: {
          columns: _vm.columns,
          tableData: _vm.dataSource,
          loading: _vm.loading,
          scroll: {},
          pagination: _vm.ipagination,
        },
        on: { change: _vm.handleTableChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }